import {useState} from "react";
import RadioButton from "../../../core/RadioButton/RadioButton";
import Checkbox from "../../../core/Checkbox/Checkbox";
import {useTranslation} from "react-i18next";
import {GAME_CONVENTIONS} from "../../../constants/index.jsx";
import React from "react";

const CreateRoomConventions = function ({handleConventionsChange}) {
    const {t} = useTranslation();
    const [combinationTypes, checkbox] = GAME_CONVENTIONS
    const [state, setState] = useState({
        combination_type: combinationTypes[0].value,
        without_boy: false,
        private_game: false,
        is_bonus: false,
    });
    const onRadioChange = ({value}) => {
        const currentState = state;
        currentState['combination_type']= value;
        setState(currentState);
        handleConventionsChange(state);

    }
    const onCheckBoxChange = ({label}) => {
        const currentState = state;
        currentState[label]= !state[label];
        setState(currentState);
        handleConventionsChange(state);
    }

    return (
        <>
            {
                combinationTypes?.map((item, index) => {
                    return (
                        <div
                            key={index}
                            className="create-room-row"
                            onClick={() => onRadioChange(item)}
                        >
                            <RadioButton
                                checked={state.combination_type === item.value}
                                title={t(`form.${item.label}`)}
                            />
                            <i className={`icon-${item.value}`}/>
                        </div>
                    )
                })
            }
            {
                checkbox?.map((item, index) => {
                    return (
                        <div
                            key={index}
                            className="create-room-row"
                            onClick={() => onCheckBoxChange(item)}
                        >
                            <Checkbox
                                checked={state[item.label]}
                                title={t(`form.${item.label}`)}
                            />
                            <i className={`icon-${item.value}`}/>
                        </div>

                    )
                })
            }
        </>
    )
}

export default CreateRoomConventions

